<template>
  <tr
    id="container-table-item"
    :key="index"
    :style="{
      cursor: 'pointer',
      backgroundColor:
        selectedRow === index ? '#cedad2' : index % 2 === 0 ? '#EEEEEE' : '#FFF',
    }"
    @click="selectRow(index)"
    @dblclick="resetSelection"
  >
    <!-- Header Columns -->
    <td
      v-for="(header, i) in headers"
      :key="i"
      :class="[
        'd-table-cell',
        'd-sm-table-cell',
        'd-print-table-cell',
        'table-item-cell',
        header.value,
        header.textAlign ? header.textAlign : 'text-left',
      ]"
    >
      <slot
        :name="`tooltip__${header.value}`"
        :item="item"
        :index="index"
      >
        <slot
          :name="header.value"
          :item="item"
          :index="index"
        >
          <template v-if="header.value === 'number_index'">
            {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
          </template>
          <template v-else-if="header.value === 'expand_action'">
            <v-btn  
              v-if="expandedItem && item.product_indicator !== 'N001'"
              icon
              small
              @click.stop="toggleExpand"
            >
              <v-icon>{{ isExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
            </v-btn>
          </template>
          <template v-else-if="header.value === 'action_api'">
            {{ item.action || 'No Action' }}
          </template>
          <template v-else-if="header.value === 'action'">
            No Action
          </template>
          <template v-else-if="header.value === 'custom'">
            Custom Item
          </template>
          <template v-else>
            {{ truncateText(getNestedValue(item, header.value), 50) }}
          </template>
        </slot>
      </slot>
    </td>

  </tr>
</template>

<script>
import truncateText from '@utils/truncateText';

export default {
  name: 'TableItem',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    headers: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      required: true,
      default: () => ({
        page: 1,
        itemsPerPage: 10,
      }),
    },
    selectedRow: {
      type: Number,
      default: null,
    },
    expandedItem: {
      type: Boolean,
      default: false,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getNestedValue(obj, path) {
      if (!obj || !path) return '';
      
      const keys = path.split('.');
      let value = obj;
      
      keys.forEach((key) => {
        if (value && typeof value === 'object') {
          value = value[key];
        } else {
          value = '';
        }
      });
      
      return value ?? '';
    },
    resetSelection() {
      this.$emit('select-row', null);
    },
    truncateText,
    selectRow(index) {
      this.$emit('select-row', index);
    },
    viewDetail(id) {
      this.$emit('view-detail', id);
    },
    toggleExpand() {
      this.$emit('toggle-expand', this.index);
    },
  },
};
</script>

<style scoped>
td {
  word-break: break-word;
}
td.number_index {
  white-space: nowrap;
  word-break: normal;
}
::v-deep .expand_action {
  padding: 0 !important;
  text-align: center;
  width: 40px;
}
::v-deep .expand_action .v-btn {
  margin: 0;
}
</style>
